import Button from "@mui/material/Button";
import styled from "styled-components";

export const ToggleButton = styled(Button)`
  width: 100%;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(1, 1.5)};
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  text-transform: none;
  color: ${({ theme }) => theme.palette.text.primary};
  border-color: ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  &:hover {
    border-color: ${({ theme }) => theme.palette.text.secondary};
    background-color: ${({ theme }) => theme.palette.action.hover};
  }

  & .MuiButton-endIcon {
    margin-left: ${({ theme }) => theme.spacing(2)};
    margin-right: 0;
  }
`;
